import { type FunctionComponent } from "react";
import { Drawer, DrawerOpen } from "@bracket/react-drawers";
import { Button } from "@bracket/react-button";
import { Table } from "@bracket/react-table";

export declare type BoostsProps = {};

export const Boosts: FunctionComponent<BoostsProps> = ({}) => {
  const classes = () => [`boosts`].join(" ");

  const routeToStake = () => {
    window.history.pushState({}, "", "/stake");
  };

  return (
    <section className={classes()}>
      <div className="info">
        <h5>All boosts are automatically applied</h5>
        <p>Expect 24hrs before for each [BARS] update.</p>
      </div>
      <div className="drawers">
        <Drawer>
          <div className="left">
            <h5>Phase boost</h5>
            <p>Boosts during certain Phases.</p>
          </div>
          <Button
            label="Stake"
            variant="primary-outline"
            className="boost-button"
            width="280px"
            onClick={routeToStake}
          />
          <DrawerOpen>
            <Table
              data={PhaseBoostData}
              keys={["phase", "perc"]}
              titles={["Phase", "Boost %"]}
            />
          </DrawerOpen>
        </Drawer>

        <Drawer>
          <div className="left">
            <h5>Size boost</h5>
            <p>Boosts for larger deposits.</p>
          </div>
          <Button
            label="Stake"
            variant="primary-outline"
            className="boost-button"
            width="280px"
            onClick={routeToStake}
          />
          <DrawerOpen>
            <Table
              data={SizeBoostData}
              keys={["category", "boost"]}
              titles={["Deposit size $", "Boost %"]}
            />
          </DrawerOpen>
        </Drawer>

        <Drawer>
          <div className="left">
            <h5>TVL boost</h5>
            <p>
              Deposits within each TVL Cap will receive a continuous points
              boost for Phase 1.
            </p>
          </div>
          <Button
            label="Stake"
            variant="primary-outline"
            className="boost-button"
            width="280px"
            onClick={routeToStake}
          />
          <DrawerOpen>
            <Table
              data={TVLBoostData}
              keys={["tvl", "boost"]}
              titles={["TVL cap", "Boost %"]}
            />
          </DrawerOpen>
        </Drawer>

        <Drawer>
          <div className="left">
            <h5>Time boost</h5>
            <p>Boosts for early staking deposits.</p>
          </div>
          <Button
            label="Stake"
            variant="primary-outline"
            className="boost-button"
            width="280px"
            onClick={routeToStake}
          />
          <DrawerOpen>
            <Table
              data={TimeBoostData}
              keys={["timeframe", "boost"]}
              titles={["Time staked (hrs)", "Boost %"]}
            />
          </DrawerOpen>
        </Drawer>

        <Drawer>
          <div className="left">
            <h5>Continuous staking</h5>
            <p>Boosts for long-term stakers.</p>
          </div>
          <Button
            label="Stake"
            variant="primary-outline"
            className="boost-button"
            width="280px"
            onClick={routeToStake}
          />
          <DrawerOpen>
            <Table
              data={ContinuousStakingData}
              keys={["phase", "boost"]}
              titles={["Phase", "Boost %"]}
            />
          </DrawerOpen>
        </Drawer>

        <Drawer disabled>
          <div className="left">
            <h5>Community rewards</h5>
            <p>Points allocated for various community incentives.</p>
          </div>
          <Button
            label="Go to quests"
            variant="primary-outline"
            className="boost-button"
            width="280px"
          />
          <DrawerOpen>
            <p>needs content</p>
          </DrawerOpen>
        </Drawer>
      </div>
    </section>
  );
};

const PhaseBoostData = [
  { phase: "Phase 1", perc: "100%" },
  { phase: "Phase 2", perc: "0%" },
];

const SizeBoostData = [
  { category: "$100K+", boost: "15%" },
  { category: "$500k+", boost: "25%" },
];

const TVLBoostData = [
  { tvl: "Up to $50mm", boost: "100%" },
  { tvl: "$50mm to $150mm", boost: "50%" },
  { tvl: "$150mm to $300mm", boost: "20%" },
];

const TimeBoostData = [
  { timeframe: "0 - 72 hours", boost: "300%" },
  { timeframe: "72 - 120 hours", boost: "100%" },
  { timeframe: "120 - 192 hours", boost: "50%" },
];

const ContinuousStakingData = [
  { phase: "Phase 1", boost: "0%" },
  { phase: "Phase 2", boost: "25% boost for 4 weeks of staking in Phase 1" },
];
